import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CertificateSelectionPage.css';
const CertificateSelectionPage = () => {
  const navigate = useNavigate();

  const handleCategorySelection = (category) => {
    navigate(`/certificate/${category}`);
  };

  return (
    <div className="container">
      <div className="intro">
        <h4>
          ECOVATE comprehensive certification program guides leaders and sales teams through the 🌱 Sustainable Materials Transition and biodegradable materials. LEARN HOW TO TRANSITION
        </h4>
        <h5>Key Benefits of Sustainable Practices</h5>
        <ul>
          <li><strong>Environmental Impact:</strong> Reduce your carbon footprint and contribute to a healthier planet.</li>
          <li><strong>Cost Efficiency:</strong> Realize long-term savings through reduced waste and energy consumption.</li>
          <li><strong>Brand Enhancement:</strong> Attract environmentally conscious customers and improve your market position.</li>
        </ul>
      </div>

      <h1 className="heading">Choose Your Package</h1>

      <div className="card-container">
        <div className="card silver">
          <h2>Silver Tier</h2>
          <img src="silver-badge.png" alt="Silver Badge" />
          <ul>
            <li>Basic certification</li>
            <li>Online training</li>
            <li>Digital badge</li>
          </ul>
          <button className="silver-button" style={{ color: 'black', backgroundColor: "#cccccc" }} onClick={() => handleCategorySelection('silver')}>Get Silver</button>
        </div>

        <div className="card gold">
          <h2>Gold Tier</h2>
          <img src="gold-badge.png" alt="Gold Badge" />
          <ul>
            <li>Advanced certification</li>
            <li>In-person workshops</li>
            <li>Marketing toolkit</li>
          </ul>
          <button className="gold-button" style={{ color: 'black', backgroundColor: "#ffd700" }} onClick={() => handleCategorySelection('gold')}>Get Gold</button>
        </div>

        <div className="card platinum">
          <h2>Platinum Tier</h2>
          <img src="platinum-badge.png" alt="Platinum Badge" />
          <ul>
            <li>Elite certification</li>
            <li>Consulting services</li>
            <li>Industry recognition</li>
          </ul>
          <button className="platinum-button" style={{ color: 'black', backgroundColor: "#e5e4e2" }} onClick={() => handleCategorySelection('platinum')}>Get Platinum</button>
        </div>
      </div>

      <div className="additional-info">
        <h5>Government Incentives</h5>
        <ul>
          <li>Tax credits for implementing sustainable practices</li>
          <li>Grants for research and development in green technologies</li>
          <li>Subsidies for energy-efficient equipment upgrades</li>
        </ul>

        <h5>GET CERTIFIED</h5>
        <p>
          <strong>Transitioning Your Company to Sustainable Materials</strong>
        </p>
        <ul>
          <li>Learn how to effectively integrate eco-friendly alternatives into your business operations.</li>
          <li>Addressing customer feedback and potential pushback</li>
          <li>Develop strategies for communicating the transition to your customers and addressing their concerns.</li>
          <li>Create a plan to present the transition to your staff and gain their support.</li>
        </ul>

        <h5>Join ECOVATE Certified Professionals</h5>
        <p>Begin your journey towards sustainability with a personalized assessment:</p>
        <ul>
          <li>Schedule a consultation with our expert team.</li>
          <li>Discover your potential Triple Bottom Line (TBL) benefits.</li>
          <li>Learn how to simultaneously reduce costs and environmental impact.</li>
        </ul>
      </div>
    </div>
  );
};

export default CertificateSelectionPage;